
if(document.querySelector('.rangeSlider')){

	var rangeSlider = document.querySelectorAll('.rangeSlider');
	var rangeSliderjQuery = $('.rangeSlider');

	for (var i = 0; i < rangeSlider.length; i++) {
		let id = rangeSlider[i].getAttribute('data-range');
		let selector = $('[data-id="'+id+'"]');
		let split = $('[data-id="'+id+'"]').attr('data-params').split(',');
		let options = [];
		let dataRange = $('[data-range="'+id+'"]');
		let dataMin = $('[data-min="'+id+'"]');
		let dataMax = $('[data-max="'+id+'"]');
		//console.log(rangeSlider[i].parentNode.parentNode.children);
		let inputValue = $(rangeSliderjQuery).eq(i).closest('.multirange').siblings('[data-params]').find('input[data-min]').val();
		let inputValue2 = $(rangeSliderjQuery).eq(i).closest('.multirange').siblings('[data-params]').find('input[data-max]').val();

		for (let i = 0; i < split.length; i++) {
			options.push(+split[i]);
		}

		noUiSlider.create(dataRange[0], {
			start: [options[2], options[3]],
			connect: true,
			range: {
				'min': options[0],
				'max': options[1]
			},
			step: options[4]
		});

		let valuesDivs = [
			dataMin[0],
			dataMax[0]
		];

		// Событие изменения бегунка когда ввели руками цифры
		if (1) {
			valuesDivs[0].addEventListener('change', function(){
				dataRange[0].noUiSlider.set([this.value, null]);
			});
			valuesDivs[1].addEventListener('change', function(){
				dataRange[0].noUiSlider.set([null, this.value]);
			});
		}

		dataRange[0].noUiSlider.on('update', function( values, handle ) {
			var value = values[handle];
			switch (handle) {
				case 1:
					var var2 = +values[1];
					valuesDivs[1].value = var2;
					break;
				case 0:
					var var1 = +values[0];
					valuesDivs[0].value = var1;
					break;
			}
			var input1 = valuesDivs[0];
			var input2 = valuesDivs[1];
			dataMin[0].setAttribute('size', String(input1.value.length));
			dataMax[0].setAttribute('size', String(input2.value.length));
		});
		dataRange[0].noUiSlider.on('set', function() {
			if(window.YAMASTERS_FRONTEND.filterEvent){
				$(document).trigger('changeFilter', dataRange[0]);
			}
		});
		valuesDivs[0].value = inputValue ? inputValue : '';
		valuesDivs[1].value = inputValue2 ? inputValue2 : '';
	}
}



// WEBPACK FOOTER //
// ./libs/multirangeContainer/multirangeContainer.js